import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { ScrollManager } from './components/ScrollManager';
import { AnalyticsTracker } from './components/AnalyticsTracker';
import { CaseStudyAccessProvider } from './contexts/CaseStudyAccessContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Home } from './pages/Home';
import { KordisCaseStudy } from './pages/KordisCaseStudy';
import { ClearDocsCaseStudy } from './pages/ClearDocsCaseStudy';
import { PalacioCaseStudy } from './pages/PalacioCaseStudy';
import { VendooCaseStudy } from './pages/VendooCaseStudy';
import { BotkeeperCaseStudy } from './pages/BotkeeperCaseStudy';
import { CognitiveBiases } from './pages/CognitiveBiases';
import { CoffeeTable } from './pages/CoffeeTable';
export function App() {
  return <ThemeProvider data-id="element-0" data-mp="28s2zfehuu3wi">
    <MotionConfig reducedMotion="user" data-id="element-1" data-mp="23vkv2fqfs7kp">
      <BrowserRouter data-id="element-2" data-mp="23ujlkfp2jt53">
        <ScrollManager data-id="element-3" data-mp="23t8heerpojdg" />
        <AnalyticsTracker data-id="element-4" data-mp="3ijxokogyjwiu" />
        <CaseStudyAccessProvider data-id="element-5" data-mp="3ikqy1x7ax04o">
          <Routes data-id="element-6" data-mp="3ijpbavgxap74">
            <Route path="/" element={<Home data-id="element-8" data-mp="3mlaxj7fckftz" />} data-id="element-7" data-mp="3ii4sg33z0up3" />
            <Route path="/work/kordis" element={<KordisCaseStudy data-id="element-10" data-mp="3mjpyb4i388ps" />} data-id="element-9" data-mp="3mkhmhu9cv461" />
            <Route path="/work/clear-docs" element={<ClearDocsCaseStudy data-id="element-12" data-mp="3rdkgg3i1ofmr" />} data-id="element-11" data-mp="3rcj7q5oi4587" />
            <Route path="/work/palacio-de-hierro" element={<PalacioCaseStudy data-id="element-14" data-mp="4wvvprmowg9" />} data-id="element-13" data-mp="3relu8fqg3g86" />
            <Route path="/work/vendoo" element={<VendooCaseStudy data-id="element-16" data-mp="2zld0746gb58w" />} data-id="element-15" data-mp="56lhc8rh1lf" />
            <Route path="/work/botkeeper" element={<BotkeeperCaseStudy data-id="element-18" data-mp="2zn66ujh2dpgw" />} data-id="element-17" data-mp="2zm4vedw4z0yn" />
            <Route path="/playground/cognitive-biases" element={<CognitiveBiases data-id="element-20" data-mp="33myjb79kwfrj" />} data-id="element-19" data-mp="33m5bs42spm8c" />
            <Route path="/playground/coffee-table" element={<CoffeeTable data-id="element-22" data-mp="38k6uup081ljt" />} data-id="element-21" data-mp="38m1e7yvuh5ls" />
            <Route path="*" element={<Home data-id="element-24" data-mp="3dle1ulujigpf" />} data-id="element-23" data-mp="38o4edbqpof48" />
          </Routes>
        </CaseStudyAccessProvider>
      </BrowserRouter>
    </MotionConfig>
    </ThemeProvider>;
}